// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"204":"80644f1e","305":"6bb3fde5","318":"264a8406","506":"80644f1e","884":"80644f1e"}[chunkId] + ".css";
};